module.exports = __webpack_public_path__ + "static/media/superscript.b7bd1c94.svg";